import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";


import { ControllerService } from '../shared/services/controller.service';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

/**
 *
 * /sometimes component
 */

@Component({
    selector: 'app-interview3-question',
    templateUrl: './interview3-question.component.html',
    styleUrls: ['./interview3-question.component.scss'],
    standalone: false
})
export class Interview3QuestionComponent implements OnInit, OnDestroy {

  questions: any = []

  components: any = []

  statement = ''

  maxCount = 0;

  currentIndex = -1;

  options: any;

  page = 0

  qpListener = null


  pageObserver = null

  pages  = []  // pages

  showNext: boolean = false
  showBack: boolean = true

  ANSWER_MAP = {
    'no' : -1,
    'sometimes': 0,
    'yes': 1
  }

  constructor(public controller: ControllerService, private chRef: ChangeDetectorRef, private route: ActivatedRoute, private doms: DomSanitizer ) { }

  loadQuestion( questionIndex ) {
          // load component.

      window.scrollTo(0,0)

      const question = this.questions[questionIndex]

      this.statement = question.statement

      this.options = [{
          label: "No",
          valid: question.answer === -1
        },
        {
          label: "Sometimes",
          valid: question.answer === 0
        },
        {
          label: "Yes",
          valid: question.answer === 1
        }
      ]

      this.pages = question.pages

      if (this.pages.length == 1) {
        this.showNext = true
      } else {
        this.showNext = false
      }

      this.currentIndex = questionIndex
      // showBack todo

  }

  sanitizeHtml( innerHtml ){
    return this.doms.bypassSecurityTrustHtml( innerHtml )
  }

  ngOnInit() {


    this.questions = this.controller.getSectionComponents().map( (component) => {

      const statement = component.elements.find( ({type}) => type == 'statement').value
      const answer = this.ANSWER_MAP[component.properties.answer.toLowerCase()]

      return {
        statement,
        answer,
        pages : component.subComponents
      }

    })


    console.log('questions: ', this.questions)

    this.qpListener = this.route.queryParams.subscribe(params => {


      if( this.controller.getStepItem().index  != this.currentIndex ){
        this.loadQuestion(this.controller.getStepItem().index  )

        // this needs to go to page 0, and set the controller to page 0.
        this.page = this.controller.getStepItem().subIndex

      }

    })

    this.pageObserver = this.controller.getPageObservers().subscribe( (page) => {

      this.page = this.controller.getStepItem().subIndex

    })

    this.maxCount = this.questions.length;

    this.updateBackground();
  }

  ngOnDestroy(): void {
    this.pageObserver.unsubscribe()
    this.qpListener.unsubscribe()
  }

  onIveSeenEverything() {
    this.showNext = true
  }

  isReady() {

    return this.pages.length > 0

  }

  responded() {
    return this.options && this.options.find((x) => x.selected)
  }

  async onBack() {

    // back needs to go to previous index. (sub-component), not page.

    await this.controller.backComponent()
  }


  async onNext() {
    // this can be visible if have seen all, so needs to go to next index (question), or next component.

    await this.controller.forwardComponent()
  }

  updateBackground() {
    $('body').removeClass();
    $('body').addClass('full-screen-bg-image welcome_1');
  }

  onSelect(event, i) {
    if (!this.options.find((x) => x.selected)) {
      const correctIndex = this.options.findIndex((x) => x.valid === true);
      this.options[i].selected = true;
      this.options[correctIndex].showCorrect = (i !== correctIndex);
      this.chRef.detectChanges();
    }
  }
}
